import { z } from 'zod';
export const AuthenticatedUserSchema = z.object({
    id: z.uuid(),
    entraOid: z.uuid(),
    email: z.email(),
    preferredUsername: z.string(),
    displayName: z.string(),
    defaultCompanyId: z.uuid(),
    allowedCompanyIds: z.array(z.uuid()),
    // RBAC (optional — populated by /auth/me for the active company; absent on
    // older responses so existing parse() calls keep working).
    roles: z.array(z.string()).optional(),
    permissions: z.array(z.string()).optional(),
});
//# sourceMappingURL=auth-user.js.map